/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import themeGet from '@pyt/ui/utils/themeGet'
import classNames from 'classnames'
import React, { Component } from 'react'
import styled, { css } from 'styled-components'

import dateUtils from '../../../utils/dateUtils'

const RateText = styled.sub`
	font-size: 11px;
	line-height: 12px;
	color: #999999;
	position: relative;
	bottom: 1px;
`

const CalendarWrapper = styled.div`
	&:before,
	&:after {
		content: ' '; // 1
		display: table; // 2
	}
	&:after {
		clear: both;
	}
	width: 100%;
	color: #53576d;
	padding: 24px;

	> section:last-of-type {
		${props =>
			props.selectNextRange &&
			css`
				margin-bottom: 30px;
			`}
	}
`

const MonthWrapper = styled.section`
	width: 100%;
	margin-bottom: 16px;

	.month-title {
		width: 100%;
		text-align: center;
		font-weight: 700;
		font-size: 16px;
		line-height: 1.5;
		letter-spacing: -0.25px;
		margin-bottom: 16px;

		span {
			font-size: 16px;
			line-height: 1.5;
			letter-spacing: -0.25px;
			font-weight: 600;
			color: #aaa;
			line-height: 1;
		}
	}

	ul {
		&:before,
		&:after {
			content: ' '; // 1
			display: table; // 2
		}
		&:after {
			clear: both;
		}

		padding-left: 0;
		list-style: none;
		margin: 0 -2px;

		li {
			float: left;
			text-align: center;
			width: 14.28%;
			padding: 0 2px;
			cursor: pointer;

			&.disabled {
				pointer-events: none;

				span {
					color: #ccc;
					cursor: not-allowed;
				}
			}

			span {
				display: inline-block;
				vertical-align: top;
				width: 32px;
				border-radius: 100%;
				background-clip: padding-box;
			}
		}

		&.date {
			li {
				font-size: 16px;
				line-height: 1.125;
				letter-spacing: -0.26px;
				margin-bottom: 8px;
				min-height: 32px;
			}
		}

		&.days {
			margin-bottom: 4px;

			li {
				font-weight: 700;
				font-size: 13px;
				line-height: 1.23;
				letter-spacing: -0.25px;
				text-transform: uppercase;
				color: #ccc;
			}
		}
	}
`

const DateWrapper = styled.ul`
	li {
		${props =>
			props.selectNextRange &&
			css`
				position: relative;
				height: 42px;
				display: flex;
				flex-direction: column;
				align-items: center;
				font-weight: 600;
				font-size: 15px;
				line-height: 24px;
				cursor: pointer;
				${props =>
					!props.showSubText &&
					css`
						justify-content: center;
					`}
			`}

		span {
			${props =>
				props.selectNextRange &&
				css`
					color: ${themeGet('colors.black')};
				`}

			font-size: ${props => (props.selectNextRange ? '15px' : '16px')};
			line-height: ${props => (props.selectNextRange ? '24px' : '32px')};
			height: ${props => (props.selectNextRange ? '24px' : '32px')};
		}

		&.active {
			${props =>
				props.selectNextRange &&
				css`
					color: ${themeGet('colors.white')};
					background-color: #00b277;
					border-top-left-radius: 100%;
					border-bottom-left-radius: 100%;
					${RateText} {
						color: ${themeGet('colors.white')};
					}
				`}
			span {
				color: ${themeGet('colors.white')};
				${props =>
					!props.selectNextRange &&
					css`
						font-weight: 700;
						background-color: #333333;
					`}
			}
		}
		&.next-active {
			background: #b2eeda;
			${RateText} {
				color: ${themeGet('colors.black')};
			}
		}
		&.last-active {
			border-top-right-radius: 100%;
			border-bottom-right-radius: 100%;
		}
		&.disabled {
			span {
				${props =>
					props.selectNextRange &&
					css`
						text-decoration: line-through;
						color: #aaaaaa;
					`}
			}
			${RateText} {
				color: #999999;
			}
		}
	}
`

const DATE_UTILS = dateUtils()

const dateInArray = (datesToDisable, queryDate) => {
	return Boolean(
		datesToDisable.filter(function (date) {
			return DATE_UTILS.isSameDate(date, queryDate)
		}).length,
	)
}

const renderUnwantedDay = balanceDayCount => {
	let elements = []
	for (let i = 0; i < balanceDayCount; i++) {
		elements.push(<li key={'date_' + i} className="visible-hidden" />)
	}
	return elements
}

export function isDisabled(minDate, currentDate, maxDate, datesToDisable) {
	const min = new Date(new Date(minDate))
	const max = new Date(new Date(maxDate))
	const current = new Date(new Date(currentDate))

	return (
		(datesToDisable && dateInArray(datesToDisable, currentDate)) ||
		!DATE_UTILS.isBetween(current, min, max)
	)
}

export function isEnable(minDate, currentDate, maxDate, datesToEnable) {
	const min = new Date(new Date(minDate))
	const max = new Date(new Date(maxDate))
	const current = new Date(new Date(currentDate))
	return (
		!dateInArray(datesToEnable, currentDate) ||
		!DATE_UTILS.isBetween(current, min, max)
	)
}

export default class CalendarPicker extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedDate: null,
		}

		this.handleSelectedDate = this.handleSelectedDate.bind(this)
		this.setSelectedDate = this.setSelectedDate.bind(this)
	}

	handleSelectedDate(e, value) {
		e && e.preventDefault()
		this.setSelectedDate(value)
		if (this.props.onSelect) {
			this.props.onSelect(value)
		}
	}

	setSelectedDate(date = new Date()) {
		const newDate = new Date(DATE_UTILS.getDateFormat(date))
		let otherState = {}

		if (this.props.selectNextRange) {
			const lastDate = DATE_UTILS.addDay(
				new Date(newDate),
				this.props.selectNextRange + 1,
			)
			otherState = {
				nextActiveRange: DATE_UTILS.getBetweenDays(newDate, lastDate),
			}
		}

		this.setState({
			selectedDate: date,
			...otherState,
		})
	}

	static getDerivedStateFromProps(props, state) {
		if (!DATE_UTILS.isSameDate(state.selectedDate, props.selectedDate)) {
			return {
				selectedDate: props.selectedDate,
			}
		}
		return null
	}

	render() {
		const { selectedDate, nextActiveRange } = this.state
		const {
			minDate,
			maxDate,
			disabledDates,
			availableDates,
			getDateSubText,
			selectNextRange,
		} = this.props
		let props = {
			minDate: minDate,
			maxDate: maxDate,
			selectedDate: selectedDate,
			handleSelect: this.handleSelectedDate,
			datesToDisable: disabledDates,
			availableDates: availableDates || [],
			getDateSubText: getDateSubText,
			selectNextRange: selectNextRange,
			nextActiveRange: nextActiveRange,
		}
		return (
			<CalendarWrapper
				className="mobile-datepicker"
				selectNextRange={getDateSubText || selectNextRange ? true : false}
			>
				<RenderCalendarYear {...props} />
			</CalendarWrapper>
		)
	}
}

export const RenderCalendarYear = props => {
	let { minDate, maxDate } = props
	let totalMonth = Math.round(DATE_UTILS.monthDiff(minDate, maxDate)) + 1
	let now = DATE_UTILS.getStartOf(minDate, 'MONTH')
	let elements = []
	for (let i = 0; i < totalMonth; i++) {
		elements.push(
			<RenderMonthCard key={i} currentMonth={new Date(now)} {...props} />,
		)
		now = DATE_UTILS.addMonth(now, 1)
	}
	return elements
}

export const RenderMonthCard = props => {
	let now = props.currentMonth
	return (
		<MonthWrapper id={DATE_UTILS.getMonthFormat(now, 'MMMM')}>
			<RenderMonthHeader date={now} />
			<RenderDayHeader />
			<RenderDays date={now} {...props} />
		</MonthWrapper>
	)
}

export const RenderMonthHeader = props => {
	let month = DATE_UTILS.getMonthFormat(props.date, 'MMMM')
	let year = DATE_UTILS.getYearFormat(props.date, 'YYYY')
	const yearContent = ` ${year}`
	return (
		<p className="month-title">
			{month}
			<span>{yearContent}</span>
		</p>
	)
}

export const RenderDayHeader = () => {
	return (
		<ul className="days">
			<li>Su</li>
			<li>Mo</li>
			<li>Tu</li>
			<li>We</li>
			<li>Th</li>
			<li>Fr</li>
			<li>Sa</li>
		</ul>
	)
}

export const RenderSingleDay = ({
	isActive,
	handleClick,
	currentValue,
	isDisabled,
	nextActiveRange,
	subText,
	showSubText,
	isLastActiveElement,
}) => {
	return (
		<li
			className={classNames('', {
				active: isActive,
				disabled: isDisabled,
				'next-active': nextActiveRange,
				'last-active': isLastActiveElement,
			})}
			onClick={e => handleClick(e, currentValue)}
		>
			<span>{currentValue.getDate()}</span>
			{showSubText ? <RateText>{subText || '--'}</RateText> : null}
		</li>
	)
}

export const RenderDays = ({
	date,
	selectedDate,
	handleSelect,
	minDate,
	maxDate,
	datesToDisable,
	availableDates = [],
	getDateSubText,
	selectNextRange,
	nextActiveRange,
}) => {
	let daysInMonth = DATE_UTILS.daysInMonth(date)
	let startDate = DATE_UTILS.getStartOf(date, 'MONTH')
	let balanceDayCount = startDate.getDay()

	let renderDay = () => {
		let elements = []
		let now = new Date(date)
		for (let i = 1; i <= daysInMonth; i++) {
			elements.push(
				<RenderSingleDay
					isActive={DATE_UTILS.isSameDate(new Date(now), selectedDate)}
					nextActiveRange={dateInArray(
						nextActiveRange || [],
						new Date(DATE_UTILS.getDateFormat(now)),
					)}
					isLastActiveElement={
						getDateSubText || selectNextRange
							? nextActiveRange && nextActiveRange.length
								? nextActiveRange[selectNextRange - 1] && selectNextRange
									? DATE_UTILS.isSameDate(
											nextActiveRange[selectNextRange - 1],
											new Date(DATE_UTILS.getDateFormat(now)),
									  )
									: false
								: DATE_UTILS.isSameDate(new Date(now), selectedDate)
							: false
					}
					subText={getDateSubText ? getDateSubText(new Date(now)) : null}
					showSubText={getDateSubText ? true : false}
					isDisabled={
						availableDates.length
							? isEnable(minDate, new Date(now), maxDate, availableDates)
							: isDisabled(minDate, new Date(now), maxDate, datesToDisable)
					}
					handleClick={handleSelect}
					currentValue={new Date(now)}
					key={'single-day-' + Math.random()}
				/>,
			)
			now = DATE_UTILS.addDay(now, 1)
		}
		return elements
	}
	return (
		<DateWrapper
			className="date"
			selectNextRange={getDateSubText || selectNextRange ? true : false}
			showSubText={getDateSubText ? true : false}
		>
			{renderUnwantedDay(balanceDayCount)}
			{renderDay()}
		</DateWrapper>
	)
}
